export interface ILoadingsReducer {
  loadings: string[]
}
export const loadingsInitialState:ILoadingsReducer = {
  loadings: []
};
